import { Link } from "react-router-dom";
import LegalShell, { Section } from "../components/LegalShell";

const SmsPolicyPage: React.FC = () => (
  <LegalShell title="SMS Terms & Opt-In Policy" updated="June 16, 2026">
    <p>
      Kinoes uses SMS text messages to help a family coordinate and decide what to do
      on a given evening. This policy explains what messages we send, how consent is
      obtained, and how to stop receiving them.
    </p>

    <Section heading="Program description">
      <p>
        When the organizer of a family group starts a plan, Kinoes sends each member a
        text with a private link to join. During a planning session you may also receive
        messages with options to vote on, the group's decision, and an optional request
        for feedback afterward. These are <strong>conversational, account-related
        messages</strong> tied to a session you were invited to — not marketing.
      </p>
    </Section>

    <Section heading="How you consent to receive messages">
      <p>
        The organizer who starts a plan provides the mobile numbers of the family members
        they wish to include, and confirms they have each person's permission to be texted
        by Kinoes for this purpose. Your first message clearly identifies Kinoes and the
        family group, and you can opt out at any time using the instructions below. By
        tapping your join link or replying to a Kinoes message, you confirm your consent
        to receive these messages.
      </p>
    </Section>

    <Section heading="Message frequency">
      <p>
        Message frequency varies and is driven by activity. A typical planning session
        results in a handful of messages over a few hours. You only receive messages
        related to sessions you have been invited to.
      </p>
    </Section>

    <Section heading="Cost">
      <p>
        Kinoes does not charge for text messages. <strong>Message and data rates may
        apply</strong> depending on your mobile carrier and plan.
      </p>
    </Section>

    <Section heading="Opt out and help">
      <p>
        Reply <strong>STOP</strong> to any Kinoes message to unsubscribe; you will receive
        a confirmation and no further messages unless you re-join. Reply <strong>HELP</strong>{" "}
        for help, or contact us at <a className="text-primary-600" href="mailto:support@kinoes.com">support@kinoes.com</a>.
        Carriers are not liable for delayed or undelivered messages.
      </p>
    </Section>

    <Section heading="Privacy">
      <p>
        We do <strong>not</strong> sell, rent, or share your mobile number or SMS opt-in
        information with third parties or affiliates for their marketing purposes. Mobile
        information is used only to deliver the Kinoes messages described above. See our{" "}
        <Link to="/privacy" className="text-primary-600">Privacy Policy</Link> for full
        details on how we handle your information.
      </p>
    </Section>
  </LegalShell>
);

export default SmsPolicyPage;
